<template>
  <div>
    <div class="tabs hide-small">
      <div :class="[ tab === 'main' ? 'active' : '' ]" @click="tab = 'main'">Main details</div>
      <div @click="tab = 'results'" :class="[ tab === 'results' ? 'active' : '' ]" v-if="this.entity.id">Results</div>
    </div>
    <div class="tabs tabs-right hide-small">
      <div :class="[ isValid ? 'valid' : 'disabled', 'save-tab' ]" @click="save(false)">{{ saveOrUpdate }}</div>
      <div :class="[ isValid ? 'valid' : 'disabled', 'save-tab' ]" @click="save(true)">{{ saveOrUpdate }} &amp; exit</div>
    </div>
    <div class="dropdown show-small dropdown-admin-tabs">
      <button class="btn dropdown-toggle" type="button" data-toggle="dropdown">
        Options
        <span class="caret"></span>
      </button>
      <ul class="dropdown-menu">
        <li @click="tab = 'main'">
          <a href="#">
            Main details
            <i class="fa fa-check-square-o" v-if="tab === 'main'"></i>
          </a>
        </li>
        <li @click="tab = 'results'" v-if="this.entity.id">
          <a href="#">
            Results
            <i class="fa fa-check-square-o" v-if="tab === 'results'"></i>
          </a>
        </li>
        <li :class="[ isValid ? 'valid' : 'disabled', 'save-dropdown' ]" @click="save(false)"><a href="#">{{ saveOrUpdate }}</a></li>
        <li :class="[ isValid ? 'valid' : 'disabled', 'save-dropdown' ]" @click="save(true)"><a href="#">{{ saveOrUpdate }} and exit</a></li>
      </ul>
    </div>
    <section id="main-content" class="clearfix">
      <div class="clearfix" slot="admin-content" id="location-content">
        <div v-if="tab === 'main'">
          <div class="col-xs-12 col-sm-6 main-location-details left top-small">
            <div class="form-group">
              <label for="cur-code" class="form-label">Code *</label>
              <input type="text" class="form-control" id="cur-code" v-model="entity.code"/>
            </div>
            <div class="form-group">
              <label for="cur-name" class="form-label">Name *</label>
              <input type="text" class="form-control" id="cur-name" v-model="entity.name"/>
            </div>
            <div class="form-group">
              <label for="cur-description" class="form-label">Description</label>
              <input type="text" class="form-control" id="cur-description" v-model="entity.description"/>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6 main-location-details left top-small">
            <div class="form-group">
              <label class="form-label">Party *</label>
              <autocomplete
                :dataset="partySearchResults"
                title="Party"
                placeHolder="Type to search"
                :initVal="entity.party"
                v-on:changing="data => partySearchText = data"
                :fnFormatText="displayParty"
                :fnSelectValue="displayParty"
                v-on:selection-made="selectOwner"
              ></autocomplete>
            </div>
            <div class="form-group">
              <label for="cur-party-ref" class="form-label">Party Ref</label>
              <input type="text" class="form-control" id="cur-party-ref" v-model="entity.partyReference"/>
            </div>
            <div class="form-group">
              <label for="date-due-date" class="form-label">Due date</label>
              <input class="mai-date" type="date" v-model="entity.dueDate"/>
            </div>
          </div>
        </div>
        <quote-uploads
          v-if="tab === 'results'"
          @mass-upload-complete="updateArchive"
          :archive="archive"
        />
      </div>
    </section>
  </div>
</template>
<script>
  import AdminEntityMixin from '../../mixins/AdminEntityMixin'
  import HelperMixin from '../../mixins/Helpers'
  import Autocomplete from '../../../helpers/AutoComplete.vue'
  import QuoteUploads from '../../../quote/components/QuoteUploads'
  import api from '../../../../api/endpoints'
  export default {
    name: 'RequestForProposal',
    mixins: [ AdminEntityMixin, HelperMixin ],
    components: {QuoteUploads, Autocomplete},
    data () {
      return {
        newEntityScreen: 'Admin - Request For Proposals',
        editEntityScreen: 'Admin - Edit/View Request For Proposals',
        shouldUpdateCache: true,
        cachePropertyName: null,
        tab: 'main',
        entity: {
          id: null,
          deleted: null,
          name: null,
          code: null,
          description: null,
          party: null,
          partyReference: null,
          dueDate: null
        },
        boxes: [],
        entityName: 'request-for-proposal',
        onLoadTransformations: {
          dueDate: this.fromTimestamp
        },
        archive: []
      }
    },
    computed: {
      isValid () {
        return this.entity.code && this.entity.name && this.entity.party
      }
    },
    methods: {
      getBaseData () {
        return {
          id: null,
          deleted: null,
          name: null,
          code: null,
          description: null,
          party: null,
          partyReference: null,
          dueDate: null
        }
      },
      selectOwner (o) {
        this.entity.party = o
        this.partySearchText = ''
        this.partySearchResults = []
      },
      refresh () {
        if (this.entity.id) {
          this.getArchive()
        } else {
          this.archive = []
        }
      },
      getArchive () {
        this.$http.get(`${api.RFP}?rfp=${this.entity.id}&sort=created,desc`)
          .then(({data}) => {
            this.archive = data.content.map(this.fromArchive)
          }).catch(console.log)
      },
      updateArchive (data) {
        const copy = { ...data }
        if (!copy.forOpti) {
          copy.data = copy.archive
        }
        this.$http.post(`${api.RFP}?rfp=${this.entity.id}&type=${data.forOpti ? 'rate' : 'workbench'}`, copy)
      },
      fromArchive (obj) {
        return {
          ...obj.data,
          forOpti: obj.type === 'MASS_OPTI',
          complete: true,
          visible: false,
          created: obj.created,
          fromArchive: true
        }
      }
    },
    watch: {
      'entity.id' (newVal, oldval) {
        this.tab = 'main'
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/modules/admin/components/RequestForProposal/RequestForProposal.vue